var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 16 16","fill":_vm.fill,"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8 3a5 5 0 100 10A5 5 0 008 3z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }